<template>
  <v-card style="margin: 0 auto;">


    <div style="height:400px;" :class="{'scrollable':true}" v-if="region_log_series.length && region_log_series[0].data.length>0 && !loading_show && show_me">
      <center>
        <apexchart width="100%" :height="height"  type="bar" style="margin: 0 auto;" :options="chartOptions" :series="region_log_series"  ref="apexChart"/>
      </center>

    </div>



    <div v-if="region_log_series.length && region_log_series[0].data.length==0 && !loading_show">
    <br>
    <br>
    <v-alert
      :value="true"
      color="success"
      icon="information"
      outline
      style="width: 80%; margin-top: 20px; margin-bottom: 20px;"
    >
      {{$t('summary.not_found')}}
    </v-alert>
    <br><br>
    </div>
  </v-card>
</template>


<script>

  import apexchart from 'vue-apexcharts'
  import Spinner from "vue-simple-spinner";

  export default {
    props: ["series","loading_show"],
    components: {
      apexchart,
      Spinner
    },

    data() {
      return {
        height: "400px",
        show_me:false,
        region_log_series: [{
          name: "IN",
          data: []
        },
          {
            name: "OUT",
            data: []
          }
        ],
        chartOptions: {
          plotOptions: {
            bar: {
              horizontal: true,
            }
          },
          dataLabels: {
            enabled: false
          },
          xaxis: {
            type: "categories",
            categories: [],
            tickAmount: 0,
            tickPlacement: "on"
          },
          legend: {
            position: 'top',
            horizontalAlign: 'left',
            offsetX: 40
          },
          chart: {
            type: 'bar',
            toolbar: {
              show: false
            }
          },
        },
      }
    },
    watch:{
      series:function(newVal,oldVal){
        if("regions_in" in newVal && "regions_out" in newVal){
          // add 70 as margin, otherwise if there is only one region graph can't show properly
          this.height= 70 + newVal.regions_in.length*80+"px";

          let regions_in=newVal.regions_in.map(x=>x.count);
          let regions_out=newVal.regions_out.map(x=>x.count);

          const max_value_region_in=Math.max(...regions_in);
          const max_value_region_out=Math.max(...regions_out);


          let tickAmount=(Math.max(max_value_region_in,max_value_region_out)<9)?Math.max(max_value_region_in,max_value_region_out):9;

          
          let categories= newVal.regions_out.map(x=>x.name);


          // series
          this.region_log_series = [
            { name: "IN", data: [...regions_in] },
            { name: "OUT", data: [...regions_out] }
          ];

          // char options
          this.$nextTick(() => {
            if(this.$refs.apexChart){
              this.$refs.apexChart.updateOptions({
                xaxis: { categories: [...categories], tickAmount: tickAmount }
              });
            }
          });

          this.show_me=true;


        }
      }
    }
  }


</script>

<style>
  .scrollable{
    overflow-y: scroll;

  }
</style>


